import styled, { css } from 'styled-components';
import { getSrcFromProps, getAlignmentFromProps, getPrimaryColorFromProps, getSizeFromProps, } from './utils/getStyleFromProps';
const svgStyles = css `
  width: ${getSizeFromProps};
  height: ${getSizeFromProps};
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  pointer-events: none;
  vertical-align: ${getAlignmentFromProps};
`;
export const IconWrapper = styled.span `
  display: inline-block;
  width: ${getSizeFromProps};
  height: ${getSizeFromProps};
  color: ${getPrimaryColorFromProps};
  fill: currentColor;
  flex-shrink: 0;
  line-height: 1;
  > svg {
    ${svgStyles}
  }
`;
export const MaskIcon = styled.span `
  ${svgStyles};
  display: inline-block;
  mask: url(${getSrcFromProps}) center center/100% 100% no-repeat;
  background-color: currentColor;
`;
